<invoice-cash-desk-edit (onClose)="close()" [medicalappointmentid]="medicalAppointmentId" ></invoice-cash-desk-edit>
